
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/payout",
      function () {
        return require("private-next-pages/settings/payout.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/payout"])
      });
    }
  